import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import Agent from "../../../Network/Agent";
import ToolBar from "../../../Components/Elements/ToolBar";
import {getGeneratedRoute, RouteEnumFinal} from "../../../Config/RouteEnum";

const CategoryProductList = React.memo(() => {

    const storeUsername = window.location.host.split(".")[0];

    const [categories, setCategories] = useState([]);

    const navigate = useNavigate()

    const getCategoryList = () => {
        Agent.Category.getListPanel(storeUsername)
            .then(response => {
                let categories = response.data.result.categories;
                setCategories(categories);
            })
            .catch(error => {
                console.log(error.response);
            });
    };

    useEffect(() => {
        getCategoryList();
    }, []);

    return (
        <div className="pb-64">
            <ToolBar
                customClasses={'box-shadow'}
                title={'دسته بندی ها'}
                navigate={() => navigate(-1)}
            />

                <div className="container mt-4">
                    <div className="row g-3">
                        <div className="col-12">
                            <Link to={getGeneratedRoute(RouteEnumFinal.PRODUCTS_QUICK_EDIT_URL_GENERATE , "all")}
                                  className="d-flex justify-content-center align-items-center p-20 td-none border bg-white">
                                <div className="mobile-h5 cl-black">همه محصولات</div>
                            </Link>
                        </div>
                        {
                            categories.map(({code , title}) => {
                                return(
                                    <div className="col-6 col-lg-3" key={code}>
                                        <Link to={getGeneratedRoute(RouteEnumFinal.PRODUCTS_QUICK_EDIT_URL_GENERATE , code)}
                                              className="d-flex justify-content-center align-items-center px-2 py-5 td-none border bg-white">
                                            <div className="mobile-h5 cl-black">{title}</div>
                                        </Link>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
        </div>
    );
});

export default CategoryProductList;
